export const services = [
    {
        id: 1,
        name: 'estp',
        title: 'Электронная торговая площадка ESTP.RU',
        shortPreferences: [
            {
                title: 'Цель',
                text: 'Увеличение эффективности поставок и поиска контрагентов за счет автоматизации.',
            },
            {
                title: 'Методика',
                text: 'Предоставление доступа к обширной базе поставщиков и автоматизация торговых операций для упрощения процессов закупок.',
            },
        ],
        longPreferences: [
            {
                title: 'Цель сервиса',
                text: 'Упрощение и ускорение процессов закупок за счет автоматизации и цифровизации торгов.',
            },
            {
                title: 'Зачем сервис нужен',
                text: 'Сервис необходим для обеспечения открытости и честности торгов, доступа к широкой базе поставщиков для заказчиков и создания условий для справедливой конкуренции.',
            },
            {
                title: 'Что он дает',
                text: [
                    'Платформа предоставляет инструменты для проведения электронных аукционов и тендеров.',
                    'Управление предложениями и автоматизация всех этапов закупочного процесса.',
                    'Уменьшение затрат на трудовые ресурсы благодаря автоматизации рутинных задач.',
                    'Увеличение прозрачности процессов закупок для контролирующих органов.',
                    'Упрощение поиска квалифицированных поставщиков, расширение возможностей для конкуренции.',
                ],
            },
            {
                title: 'Результат',
                text: [
                    'Экономия средств заказчиками за счет увеличения конкуренции среди поставщиков.',
                    'Снижение затрат на управление закупками и упрощение процесса выбора поставщиков.',
                    'Обеспечение прозрачности торговых процедур для всех участников рынка и контролирующих органов.',
                ],
            },
        ],
        videoLink:
            'https://estp.ru/upload/front-file/public/services/estpcus.mp4',
        conditions: [
            {
                title: 'Электронная торговая площадка ESTP.RU',
                texts: [
                    {
                        text: 'Стоимость подключения',
                        price: 'Согласно тарифам',
                        link: 'https://estp.ru/tariffs/customers',
                    },
                ],
            },
        ],
    },
    {
        id: 2,
        name: 'searchForSuppliers',
        title: 'Поиск Поставщиков',
        shortPreferences: [
            {
                title: 'Цель',
                text: 'Максимальное целевое информирование о вашем тендере.',
            },
            {
                title: 'Методика',
                text: 'Отбор компаний, мотивация к участию.',
            },
            {
                title: 'Результат',
                text: 'Качественные кандидаты, ценная обратная связь.',
            },
        ],
        longPreferences: [
            {
                title: 'Цель',
                text: 'Максимизировать охват целевых поставщиков, предоставляя детальную информацию о вашем тендере.',
            },
            {
                title: 'Зачем сервис нужен',
                text: 'Чтобы увеличить количество качественных предложений от поставщиков, специализирующихся на необходимых товарах или услугах.',
            },
            {
                title: 'Что он делает',
                text: 'Мы вручную отбираем компании, точно соответствующие критериям вашей закупки. Наша команда не просто уведомляет их, но и активно мотивирует к участию, обсуждая детали тендера и предлагая помощь в подготовке предложений.',
            },
            {
                title: 'Результат',
                text: 'Вы получаете не только список потенциальных поставщиков, но и обратную связь, которая позволит вам своевременно адаптировать условия тендера для привлечения наиболее подходящего поставщика.',
            },
        ],
        videoLink:
            'https://estp.ru/upload/front-file/public/services/searchForSuppliers.mp4',
        conditions: [
            {
                title: 'Рассылка участникам и формирование базы',
                texts: [
                    {
                        text: '«Одна закупка»',
                        price: '1 500 ₽',
                    },
                    {
                        text: 'Абонемент 1 месяц (до 15 закупок)',
                        price: '20 000 ₽',
                    },
                    {
                        text: 'Абонемент 6 месяцев (до 100 закупок)',
                        price: '100 000 ₽',
                    },
                    {
                        text: 'Абонемент 1 год (до 250 закупок)',
                        price: '180 000 ₽',
                    },
                ],
            },
            {
                title: 'Проведение звонков потенциальным участникам',
                texts: [
                    {
                        text: '«Одна закупка»',
                        price: '5 500 ₽',
                    },
                    {
                        text: 'Абонемент 1 месяц (до 15 закупок)',
                        price: '45 000 ₽',
                    },
                    {
                        text: 'Абонемент 6 месяцев (до 100 закупок)',
                        price: '230 000 ₽',
                    },
                    {
                        text: 'Абонемент 1 год (до 250 закупок)',
                        price: '400 000 ₽',
                    },
                ],
            },
        ],
    },
    {
        id: 3,
        name: 'assistant',
        title: 'Тендерный ассистент',
        shortPreferences: [
            {
                title: 'Цель сервиса',
                text: 'Прозрачность операций для налоговых органов.',
            },
            {
                title: 'Что получает клиент',
                text: 'Аутсорсинг отдела закупок, экономия до 17% закупочных расходов. ',
            },
            {
                title: 'Результат',
                text: 'Доступ к проверенным поставщикам, минимизация рисков.',
            },
        ],
        videoLink:
            'https://estp.ru/upload/front-file/public/services/assistant.mp4',
        longPreferences: [
            {
                title: 'Цель сервиса',
                text: 'Предоставление комплексного решения для автоматизации и оптимизации закупочных процессов в коммерческих компаниях, сокращение затрат и повышение прозрачности для налоговых органов.',
            },
            {
                title: 'Что получает клиент',
                text: [
                    'Внешний отдел закупок "под ключ"',
                    'Полное управление процессом закупок без необходимости содержания собственного персонала. Экономия до 17%',
                    'Снижение закупочных расходов за счет эффективного управления тендерами и анализа рыночных предложений',
                    'Прозрачность и безопасность: Гарантия легитимности всех закупочных операций перед налоговыми органами, минимизация рисков при выборе поставщиков',
                    'Проверка и верификация контрагентов: Доступ к базе проверенных поставщиков, исключение ненадежных партнеров',
                    'Присоединение к лучшим практикам: Использование передовых технологий и методик электронных закупок, применяемых крупными компаниями.',
                ],
            },
            {
                title: 'Преимущества для бизнеса',
                text: 'Сокращение времени и усилий, затрачиваемых на процесс закупок. Увеличение прозрачности и уверенности в закупочных операциях. Оптимизация бюджета и повышение эффективности расходования средств. Комплексный подход к управлению закупками, от поиска поставщиков до контроля за исполнением контрактов.',
            },
            {
                title: 'Результат',
                text: '"Тендерный ассистент"" позволяют вашему бизнесу сократить затраты, обеспечить прозрачность закупочных процедур перед налоговыми органами и оптимизировать внутренние процессы, обеспечивая стабильное развитие и рост.',
            },
        ],
        conditions: [
            {
                title: 'Размещение извещения за заказчика',
                texts: [
                    {
                        text: 'Разовая услуга',
                        price: '2 000 ₽',
                    },
                    {
                        text: 'Абонемент 1 месяц (до 30 закупок)',
                        price: '30 000 ₽',
                    },
                    {
                        text: 'Абонемент 1 месяц (до 50 закупок)',
                        price: '45 000 ₽',
                    },
                    {
                        text: 'Абонемент 1 месяц (до 100 закупок)',
                        price: '80 000 ₽',
                    },
                    {
                        text: 'Абонемент 1 месяц (до 200 закупок)',
                        price: '150 000 ₽',
                    },
                ],
            },
            {
                title: 'Подготовка тендерной документации',
                texts: [
                    {
                        text: 'Разовая услуга',
                        price: '7 000 ₽',
                    },
                    {
                        text: 'Абонемент 1 месяц (до 30 документаций)',
                        price: '85 000 ₽',
                    },
                    {
                        text: 'Абонемент 1 месяц (до 50 документаций)',
                        price: '110 000 ₽',
                    },
                    {
                        text: 'Абонемент 1 месяц (до 100 документаций)',
                        price: '200 000 ₽',
                    },
                    {
                        text: 'Абонемент 1 месяц (до 200 документаций)',
                        price: '350 000 ₽',
                    },
                ],
            },
        ],
    },
    {
        id: 5,
        name: 'contractors',
        title: 'Управление контрагентами',
        shortPreferences: [
            {
                title: 'Цель',
                text: 'Эффективное управление и оценка контрагентов.',
            },
            {
                title: 'Методика',
                text: 'Автоматизация сбора данных, гибкое ранжирование, аккредитация и классификация.',
            },
            {
                title: 'Результат',
                text: 'Повышение надежности сотрудничества.',
            },
        ],
        longPreferences: [
            {
                title: 'Цель',
                text: 'Повышение эффективности взаимодействия с контрагентами за счет централизации информации и автоматизации управления.',
            },
            {
                title: 'Зачем сервис нужен',
                text: 'Для единой оценки и классификации контрагентов, устранения дублирования оценок в разных отделах, и обеспечения доступа к полной истории взаимодействия и отзывам сотрудников.',
            },
            {
                title: 'Что он делает',
                text: [
                    'Создает единую базу данных контрагентов, устраняя разрозненные внутренние классификации.',
                    'Обеспечивает хранение истории взаимодействий и мнений о контрагентах, доступных всем уполномоченным сотрудникам.',
                    'Позволяет автоматизировать процессы оценки, аккредитации и согласования контрагентов.',
                    'Формирует гибкий рейтинг контрагентов, отражающий актуальное состояние сотрудничества.',
                ],
            },
            {
                title: 'Результат',
                text: 'Ускорение процессов принятия решений, повышение качества и надежности взаимодействия с контрагентами, гармонизация внутренних процессов оценки.',
            },
        ],
        videoLink: 'https://estp.ru/upload/front-file/public/video2.mp4',
        conditions: [
            {
                title: 'Управление контрагентами',
                texts: [
                    {
                        text: 'Абонемент 1 месяц',
                        price: '30 000 ₽',
                    },
                    {
                        text: 'Абонемент 6 месяцев',
                        price: '160 000 ₽',
                    },
                    {
                        text: 'Абонемент 1 год',
                        price: '300 000 ₽',
                    },
                ],
            },
        ],
    },
    {
        id: 6,
        name: 'supplyOffersReport',
        title: 'Аналитическая Таблица',
        shortPreferences: [
            {
                title: 'Упрощение выбора',
                text: 'Индивидуальная таблица для сравнения предложений.',
            },
            {
                title: 'Методика',
                text: 'Автоматизированное ранжирование по бизнес-критериям, выделение ключевых моментов.',
            },
            {
                title: 'Результат',
                text: 'Оптимизация тендерных процессов.',
            },
        ],
        longPreferences: [
            {
                title: 'Цель',
                text: 'Сокращение времени на подведение итогов тендеров, улучшение качества анализа предложений.',
            },
            {
                title: 'Описание',
                text: 'Создайте эксклюзивную таблицу для сравнения коммерческих предложений, интегрированную с вашими бизнес-процессами. Наш сервис позволяет выделять ключевые моменты и риски, упрощая процесс выбора лучшего поставщика.',
            },
            {
                title: 'Особенности',
                text: 'Индивидуализация с учетом ваших бизнес-критериев и предпочтений. Возможность выделения и ранжирования предложений по степени риска и важности, облегчая принятие решений.',
            },
            {
                title: 'Результат',
                text: 'Быстрое и обоснованное принятие решений на основе полного и четкого сравнения всех предложений, существенное сокращение времени проведения тендерных комитетов, акцент на выявлении рисков и упрощение процесса выбора.',
            },
        ],
        videoLink: 'https://estp.ru/upload/front-file/public/video7.mp4',
        conditions: [
            {
                title: 'Персональная Аналитическая Таблица',
                texts: [
                    {
                        text: 'Стоимость подключения',
                        price: '100 000 Р',
                    },
                    {
                        text: 'Срок использования',
                        price: 'Бессрочно',
                    },
                ],
            },
        ],
    },
    {
        id: 7,
        name: 'purchasesFromFile',
        title: 'Закупки из смет',
        shortPreferences: [
            {
                title: 'Цель',
                text: 'Обеспечение точности и прозрачности при формировании предложений, исключая риск человеческой ошибки.',
            },
            {
                title: 'Результат',
                text: 'Быстрое создание и публикация закупок, эффективное сравнение смет, выявление завышения цен.',
            },
        ],
        longPreferences: [
            {
                title: 'Цель',
                text: 'Гарантия точности и прозрачности в сравнении предложений без человеческих ошибок.',
            },
            {
                title: 'Зачем этот сервис',
                text: 'Ускоряет процесс публикации закупок, позволяя работать с большим объемом данных и детально анализировать каждую смету. Этот сервис является ключевым инструментом для упрощения и повышения точности проведения закупочных процессов, предоставляя возможность эффективного сравнения и анализа смет, что способствует более обоснованному принятию решений',
            },
            {
                title: 'Что делает сервис',
                text: 'Преобразует сметы и расчетные ведомости в структурированные данные, упрощая сравнение предложений по каждой позиции и выявление необоснованных цен.',
            },
            {
                title: 'Результат',
                text: 'Сокращение времени на подготовку закупок и публикацию, точное выявление завышенных цен среди тысяч позиций, подготовка к автоматизации последующих процессов.',
            },
        ],
        videoLink: 'https://estp.ru/upload/front-file/public/video1.mp4',
        conditions: [
            {
                title: 'Закупки из смет',
                texts: [
                    {
                        text: 'Подключение',
                        price: '150 000 ₽',
                    },
                    {
                        text: 'Абонемент 1 месяц',
                        price: '35 000 ₽',
                    },
                ],
            },
        ],
    },
    {
        id: 8,
        name: 'approvals',
        title: 'Согласования',
        shortPreferences: [
            {
                title: 'Цель',
                text: 'Оптимизация согласования через гибкую настройку порядка и критериев.',
            },
            {
                title: 'Методика',
                text: 'Гибкий конструктор для настройки процессов.',
            },
            {
                title: 'Результат',
                text: 'Эффективное управление с автоматизированной ведомостью.',
            },
        ],
        longPreferences: [
            {
                title: 'Цель',
                text: 'Упрощение и ускорение процессов согласования в организации на всех уровнях.',
            },
            {
                title: 'Зачем сервис нужен',
                text: 'Для гибкой настройки и автоматизации процессов согласования документов и решений, что способствует более быстрому принятию решений и улучшению внутренней координации.',
            },
            {
                title: 'Что он делает',
                text: [
                    'Позволяет выстроить индивидуальный процесс согласования для различных сущностей (договоров, протоколов, участников, закупок).',
                    'Возможность настройки последовательного и параллельного порядка согласований.',
                    'Установка конкретных критериев и условий для каждого этапа согласования.',
                    'Автоматическое формирование итоговой ведомости согласований для прозрачности и отчетности.',
                ],
            },
            {
                title: 'Результат',
                text: 'Ускоренный и более эффективный процесс согласования с максимальной прозрачностью и отслеживанием всех этапов.',
            },
        ],
        videoLink: 'https://estp.ru/upload/front-file/public/video3.mp4',
        conditions: [
            {
                title: 'Согласования',
                texts: [
                    {
                        text: 'Абонемент 1 месяц',
                        price: '20 000 ₽',
                    },
                    {
                        text: 'Абонемент 6 месяцев',
                        price: '80 000 ₽',
                    },
                ],
            },
        ],
    },
    {
        id: 9,
        name: 'crm',
        title: 'CRM–управление закупками',
        shortPreferences: [
            {
                title: 'Цель',
                text: 'Существенное сокращение времени и усилий на тендерные процедуры.',
            },
            {
                title: 'Методика',
                text: 'Улучшение внутренней безопасности.',
            },
            {
                title: 'Результат',
                text: 'Оптимизация процесса согласований и аналитики.',
            },
        ],
        longPreferences: [
            {
                title: 'Цель',
                text: 'Эффективное управление процессами закупочной деятельности для застройщиков, обеспечение эффективной работы тендерных комитетов и повышение прозрачности тендерных процедур.',
            },
            {
                title: 'Зачем сервис нужен',
                text: 'Для минимизации ручного труда при формировании потребностей от различных отделов, автоматизации сбора и анализа данных по тендерам, а также для оптимизации процессов внутренних согласований и обеспечения безопасности тендерных операций.',
            },
            {
                title: 'Что он делает',
                text: [
                    'Автоматизирует процесс формирования закупок из потребностей различных отделов.',
                    'Оптимизирует проведение тендерных комитетов, сокращая время на принятие решений.',
                    'Предоставляет подробную аналитику по каждому объекту строительства и видам работ, учитывая эффективность и предыдущую историю участников.',
                    'Включает инструменты для внутренней службы безопасности, минимизируя риски и вопросы к тендерным отделам.',
                    'Упрощает согласование тендерных протоколов и обеспечивает сводную аналитику по всем закупкам и участникам',
                ],
            },
            {
                title: 'Результат',
                text: 'Значительное упрощение и ускорение процессов закупок, повышение безопасности и прозрачности тендерных процедур, улучшение качества аналитических данных для принятия обоснованных решений.',
            },
        ],
        videoLink: 'https://estp.ru/upload/front-file/public/video4.mp4',
        conditions: [
            {
                title: 'CRM – управление закупками',
                texts: [
                    {
                        text: 'Абонемент 1 месяц',
                        price: '50 000 ₽',
                    },
                    {
                        text: 'Абонемент 6 месяцев',
                        price: '250 000 ₽',
                    },
                    {
                        text: 'Абонемент 12 месяцев',
                        price: '470 000 ₽',
                    },
                ],
            },
        ],
    },
    {
        id: 10,
        name: 'sms',
        title: 'СМС Оповещения',
        shortPreferences: [
            {
                title: 'Цель',
                text: 'Автоматизация оповещений с максимальным охватом.',
            },
            {
                title: 'Методика',
                text: 'Самостоятельный выбор адресатов для мгновенной доставки СМС.',
            },
            {
                title: 'Результат',
                text: 'Непосредственное взаимодействие и увеличение отклика.',
            },
        ],
        longPreferences: [
            {
                title: 'Цель',
                text: 'Дать вам возможность быстро и эффективно информировать целевую аудиторию о ваших предложениях и тендерах через СМС.',
            },
            {
                title: 'Зачем сервис нужен',
                text: 'Если вам необходимо обеспечить максимальный охват и мгновенную реакцию на ваши сообщения, без привлечения внешних баз данных.',
            },
            {
                title: 'Что он делает',
                text: 'Позволяет вам самостоятельно создать список получателей и отправить им персонализированные СМС-сообщения, используя собственную базу контактов.',
            },
            {
                title: 'Результат',
                text: 'Непосредственное взаимодействие с вашей аудиторией, увеличенный отклик на ваши инициативы, повышение эффективности коммуникаций.',
            },
        ],
        videoLink: 'https://estp.ru/upload/front-file/public/services/sms.mp4',
        conditions: [
            {
                title: 'СМС Оповещения',
                texts: [
                    {
                        text: 'Стоимость подключения',
                        price: '10 000 Р',
                    },
                    {
                        text: 'При подключении сервиса, первый месяц использования будет бесплатным',
                    },
                    {
                        text: 'Абонемент 1 месяц',
                        price: 'По факту количества отправленных СМС в течение месяца',
                    },
                ],
            },
        ],
    },
    {
        id: 11,
        name: 'workReference',
        title: 'Справочники работ',
        shortPreferences: [
            {
                title: 'Цель',
                text: 'Упрощение аналитики и проведение базовых ценовых расчётов.',
            },
            {
                title: 'Методика',
                text: 'Создание индивидуальных справочников для точной аналитики и предварительных ценовых оценок.',
            },
        ],
        longPreferences: [
            {
                title: 'Цель',
                text: 'Повышение точности и эффективности планирования закупок через персонализированные справочники и аналитику',
            },
            {
                title: 'Зачем сервис нужен',
                text: 'Для точной аналитики, упрощения расчётов и оптимизации процесса подготовки к тендерам.',
            },
            {
                title: 'Что он делает',
                text: [
                    'Обеспечивает создание и поддержание актуальности персональных справочников товаров, работ и услуг.',
                    'Дает возможность проведения детализированной аналитики и базовых ценовых расчётов на основе собранных данных.',
                    'Позволяет интегрировать справочники с внутренними системами для повышения точности прогнозирования и планирования.',
                ],
            },
            {
                title: 'Результат',
                text: 'Улучшенное прогнозирование стоимости потенциальных тендеров и оптимизация закупочных стратегий.',
            },
        ],
        videoLink: 'https://estp.ru/upload/front-file/public/video9.mp4',
        conditions: [
            {
                title: 'Справочники работ',
                texts: [
                    {
                        text: 'Стоимость подключения',
                        price: '50 000 Р',
                    },
                    {
                        text: 'Срок использования',
                        price: 'Бессрочно',
                    },
                ],
            },
        ],
    },
    {
        id: 12,
        name: 'realtyAuction',
        title: 'Аукцион по продаже недвижимости',
        shortPreferences: [
            {
                title: 'Цель сервиса',
                text: 'Максимизация прибыли от продажи недвижимости.',
            },
            {
                title: 'Методика',
                text: 'Организация аукционов.',
            },
            {
                title: 'Результат',
                text: 'Увеличение итоговой стоимости оперативная продажа, и возможность проведения промо-акций.',
            },
        ],
        videoLink:
            'https://estp.ru/upload/front-file/public/services/realtyAuction.mp4',
        longPreferences: [
            {
                title: 'Цель сервиса',
                text: 'Обеспечение застройщиков надежным и прозрачным механизмом аукционов для продажи недвижимости, позволяющим оптимизировать и ускорить процесс продаж.',
            },
            {
                title: 'Зачем сервис нужен',
                text: 'Сервис предназначен для застройщиков, желающих продать недвижимость эффективно и с минимальными временными затратами. Особенно актуален для объектов, требующих быстрой реализации или специального подхода к продаже.',
            },
            {
                title: 'Что он делает',
                text: [
                    'Предоставляет платформу для проведения аукционов по продаже недвижимости с гарантией прозрачности сделок.',
                    'Позволяет застройщикам выставлять объекты недвижимости на аукцион, обеспечивая оперативное привлечение заинтересованных покупателей.',
                    'Гарантирует прозрачность процесса продажи, повышая доверие покупателей и обеспечивая справедливую рыночную стоимость объектов.',
                ],
            },
            {
                title: 'Результат',
                text: 'Сервис позволяет застройщикам сократить время продажи недвижимости, обеспечив при этом ее реализацию по справедливой рыночной стоимости. Прозрачность и надежность аукционов повышают доверие как со стороны продавцов, так и покупателей',
            },
        ],
        conditions: [
            {
                title: 'Аукцион по продаже недвижимости',
                texts: [
                    {
                        text: 'Подключение',
                        price: '150 000 ₽',
                    },
                    {
                        text: 'Одно извещение',
                        price: '12 000 ₽',
                    },
                ],
            },
        ],
    },
    {
        id: 16,
        name: 'estp1',
        title: 'Электронная торговая площадка ESTP.RU',
        shortPreferences: [
            {
                title: 'Цель',
                text: 'Помочь вам находить новых заказчиков и контракты для бизнеса.',
            },
            {
                title: 'Методика',
                text: 'Участие в электронных закупках на площадке, оплата за сервис производится только в случае выигрыша в тендере.',
            },
            {
                title: 'Результат',
                text: 'Новые договоры, развитие компании и рост прибыли.',
            },
        ],
        longPreferences: [
            {
                title: 'Цель сервиса',
                text: 'Предоставить доступ к новым заказчикам и контрактам для развития вашего бизнеса.',
            },
            {
                title: 'Зачем сервис нужен',
                text: 'Развитие вашей компании через доступ к контрактам корпоративного и госсектора, открывающий новые возможности и рынки.',
            },
            {
                title: 'Что он дает',
                text: 'Предоставляет возможность подавать предложения в электронном виде на интересующие закупки, обеспечивает участие в электронных закупках через нашу платформу. Оплата за использование сервиса взимается только в случае победы в тендере, что делает участие в закупках более доступным.',
            },
            {
                title: 'Результат',
                text: 'Доступ к новым договорам способствует росту и развитию вашего бизнеса, а также увеличивает прибыль, с минимальными рисками благодаря условию оплаты только при успешном исходе тендера.',
            },
        ],
        videoLink:
            'https://estp.ru/upload/front-file/public/services/estppar.mp4',
        conditions: [
            {
                title: 'Электронная торговая площадка ESTP.RU',
                texts: [
                    {
                        text: 'Стоимость подключения',
                        price: 'Согласно тарифам',
                        link: 'https://estp.ru/tariffs/licenses',
                    },
                ],
            },
        ],
    },
    {
        id: 17,
        name: 'fast_akk',
        title: 'Ускоренная аккредитация',
        shortPreferences: [
            {
                title: 'Цель',
                text: 'Стандартная аккредитация в соответствии с действующим договором оферты осуществляется в течение 7-ми дней. Ускоренная в течение 3 часов. Активацию необходимо подтвердить в контактном центре.',
            },
        ],
        longPreferences: [
            {
                title: 'Описание сервиса',
                text: 'Стандартная аккредитация в соответствии с действующим договором оферты осуществляется в течение 7-ми дней. Ускоренная в течение 3 часов. Активацию необходимо подтвердить в контактном центре.',
            },
        ],
        videoLink: '123',
        conditions: [
            {
                title: 'Ускоренная аккредитация',
                texts: [
                    {
                        text: 'Стоимость подключения',
                        price: '6 000 Р',
                    },
                ],
            },
        ],
    },
    {
        id: 18,
        name: 'prepayment',
        title: 'Ускоренное зачисление',
        shortPreferences: [
            {
                title: 'Цель',
                text: 'Стандартное зачисление денежных средств на лицевой счет в соответствии с договором оферты осуществляется на следующий рабочий день. Ускоренная в течение 3 часов. (При предъявлении платежных документов) Активацию необходимо подтвердить в контактном центре.',
            },
        ],
        longPreferences: [
            {
                title: 'Описание сервиса',
                text: 'Стандартное зачисление денежных средств на лицевой счет в соответствии с договором оферты осуществляется на следующий рабочий день. Ускоренная в течение 3 часов. (При предъявлении платежных документов) Активацию необходимо подтвердить в контактном центре.',
            },
        ],
        videoLink: '123',
        conditions: [
            {
                title: 'Ускоренное зачисление',
                texts: [
                    {
                        text: 'Стоимость подключения',
                        price: '2 000 Р',
                    },
                ],
            },
        ],
    },
    {
        id: 20,
        name: 'cloud_storage',
        title: 'Облачное хранилище',
        shortPreferences: [
            {
                title: '',
                text: 'Храните ваши документы в защищённом хранилище',
            },
            {
                title: '',
                text: 'Используйте документы из хранилища для подачи заявок',
            },
            {
                title: '',
                text: 'Доступ на 30 дней',
            },
        ],
        longPreferences: [
            {
                title: 'Описание сервиса',
                text: 'Храните ваши документы в защищённом хранилище',
            },
            {
                title: 'Удобство',
                text: 'Используйте документы из хранилища для подачи заявок',
            },
            {
                title: 'Условия',
                text: 'Доступ на 30 дней',
            },
        ],
        videoLink: '123',
        conditions: [
            {
                title: 'Облачное хранилище',
                texts: [
                    {
                        text: 'Стоимость услуги (30 дней)',
                        price: '6 000 Р',
                    },
                ],
            },
        ],
    },
];

export const customersServicesNames = [
    'estp',
    'searchForSuppliers',
    'assistant',
    'contractors',
    'supplyOffersReport',
    'purchasesFromFile',
    'approvals',
    'crm',
    'sms',
    'workReference',
    'realtyAuction',
];
export const particiantsServicesNames = [
    'estp1',
    'fast_akk',
    'prepayment',
    'cloud_storage',
];
